var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"ds-form",attrs:{"novalidate":"true","autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_vm._t("default",null,{"errors":_vm.errors,"reset":_vm.reset})],2)}
var staticRenderFns = []

export { render, staticRenderFns }